import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { useClient } from '@plone/volto/hooks/client/useClient';

const GTM_ID = 'GTM-MKJSBMR';
const FB_PIXEL_ID = '1484556978608006';
const IOMA_PATH_SUFFIX = '/serveis-medics/unitats-especialitzades/ioma';

function initGtm() {
  if (typeof window === 'undefined' || window.__csjGtmLoaded) {
    return;
  }
  window.__csjGtmLoaded = true;
  /* eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);
  /* eslint-enable */
}

function initFacebookPixel() {
  if (typeof window === 'undefined' || window.fbq) {
    return;
  }
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );
  window.fbq('consent', 'revoke');
  window.fbq('init', FB_PIXEL_ID);
  /* eslint-enable */
}

function sendFacebookPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('consent', 'grant');
    window.fbq('track', 'PageView');
  }
}

/**
 * GTM (always on client) and Facebook Pixel on IOMA when analytics cookies accepted.
 * GA is handled by volto-dsgvo-banner Google.jsx when confirm_tracking is set.
 */
const DsgvoAnalyticsBridge = () => {
  const isClient = useClient();
  const [cookies] = useCookies();
  const location = useLocation();
  const gtmInitialized = useRef(false);

  const trackingAllowed = !!Number(cookies.confirm_tracking);

  useEffect(() => {
    if (!isClient || gtmInitialized.current) {
      return;
    }
    gtmInitialized.current = true;
    initGtm();
    initFacebookPixel();
  }, [isClient]);

  useEffect(() => {
    if (!isClient || !trackingAllowed) {
      return;
    }
    const path = location.pathname.replace(/\/+$/, '') || '/';
    if (path.endsWith(IOMA_PATH_SUFFIX)) {
      sendFacebookPageView();
    }
  }, [isClient, trackingAllowed, location.pathname]);

  return null;
};

export default DsgvoAnalyticsBridge;
